<template>
  <div class="covenant-detail">
    <div v-if="loading" class="loading">加载中...</div>
    <div v-else-if="!agreement" class="empty">协议不存在或已下架</div>
    <template v-else>
      <h1 class="title">{{ agreement.title }}</h1>
      <div class="content" v-html="agreement.content"></div>
    </template>
  </div>
</template>
<script>
const SCENE_TYPE = 'VENUE_CARD_TRIAL'
export default {
  data() {
    return {
      loading: true,
      agreement: null
    }
  },
  created() {
    this.loadCovenant()
  },
  methods: {
    loadCovenant() {
      const code = this.$route.query.code
      this.$http
        .getArena('/api/v1/covenant/list', { sceneType: SCENE_TYPE })
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            const list = (res.data && res.data.agreements) || []
            this.agreement = list.find((i) => i.code === code) || null
          } else {
            this.$dialog.alert({ message: res.msg || '协议加载失败' })
          }
        })
        .catch(() => {
          this.$dialog.alert({ message: '网络异常，请稍后重试' })
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.covenant-detail {
  min-height: 100vh;
  background: #f5f5f5;
  padding: 16px;
  box-sizing: border-box;
  font-family: PingFangSC-Regular, PingFang SC;
}
.loading,
.empty {
  text-align: center;
  padding: 80px 0;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.5);
}
.title {
  font-size: 18px;
  font-weight: 600;
  color: rgba(5, 11, 39, 1);
  line-height: 26px;
  margin: 4px 0 16px;
}
.content {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.85);
  line-height: 22px;
  word-break: break-all;
}
</style>
